import { Button, Dialog } from '@mui/material'

import useGlobalStyles from '../style'
import useStyles from './style'

const UnsavedChangesDialog = ({ open, onClose, onDiscard }) => {
  const globalClasses = useGlobalStyles()
  const classes = useStyles()

  return (
    <Dialog open={open} onClose={onClose} aria-describedby="unsaved-changes-warning">
      <div className={classes.dialog}>
        <div id="unsaved-changes-warning" className={classes.text}>
          <span>Warning:</span> there are unsaved changes
        </div>
        <div className={classes.actions}>
          <Button variant="outlined" color="secondary" className={classes.discard_btn} onClick={onDiscard}>
            Close without saving
          </Button>
          <Button autoFocus variant="contained" color="secondary" className={globalClasses.save_btn} onClick={onClose}>
            Keep editing
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

export default UnsavedChangesDialog
